
import Vue from "vue";
import { GoogleCalendarService } from "../../services/google-calendar-service";
import AppCalendarListItem from "./CalendarListItem.vue";

export default Vue.extend({
	props: {
		calendar: {
			type: Object as () => gapi.client.calendar.CalendarListEntry,
			required: true
		},
		active: {
			type: Boolean
		}
	},
	methods: {
		edit() {
			this.$emit("edit");
		},
		async remove() {
			let confirm = await this.$confirmBuilder().setWarningTitle().setMessage(this.$ct("confirm-calendar-delete", {name: this.calendar.summary})).show();
			if (!confirm) {
				return;
			}

			await GoogleCalendarService.deleteCalendar(this.calendar.id);
			this.$emit("delete");
		},
		load() {
			this.$emit("load");
		}
	},
	components: {
		AppCalendarListItem
	},
	i18nEx: {
		componentPrefix: "components.calendar"
	}
});
